<template>
  <div>
    <input v-show="false" ref="excelInput" type="file" @change="readFile" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" />
    <slot name="header"/>
    <div>
      <div class="flex justify-between items-center mt-6 mb-4">
        <h5>
          <slot name="title">
            <i class="dot"></i> <span class="inline-flex items-center" v-html="tableTitle"></span>
          </slot>
        </h5>
        <vs-button v-if="!readonly" color="secondary" type="border" @click="onClickCheckRemove">선택삭제</vs-button>
      </div>
      <div class="w-full overflow-x-auto">
        <table v-if="readonly">
          <colgroup><slot name="colgroup" :readonly="true"></slot></colgroup>
          <thead><slot name="thead">
            <tr>
              <th v-for="th in tableHeader" v-html="th"></th>
            </tr>
          </slot></thead>
          <tbody>
          </tbody>
        </table>
        <table v-else>
          <colgroup>
            <col width="40px"/>
            <col width="53px"/>
            <slot name="colgroup"></slot>
            <col width="94px"/>
          </colgroup>
          <thead><slot name="thead">
            <tr>
              <th><vs-checkbox :value="0 < excelData.length && excelData.length === checkList.length" @click.native="checkAll" class="check" /></th>
              <th><div class="triangle-down cursor-pointer" :class="{'open': openAll}" @click="onClickOpenAll">
                <svg
                  width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.3335 23.168L20.0002 16.5013L13.3335 9.83464L13.3335 23.168Z" fill="black"/>
                </svg>
              </div></th>
              <th v-for="th in tableHeader" v-html="th"></th>
              <th>수정/삭제</th>
            </tr>
          </slot></thead>
          <tbody v-for="(excel, rowIndex) in excelData" :key="`excelData_${rowIndex}`">
            <tr>
              <td><vs-checkbox :value="0 < excelData.length && excelData.length === checkList.length" @click.native="checkAll" class="check" /></td>
              <td>
                <div class="triangle-down cursor-pointer" :class="{'open': excel.open}" @click="excel.open = !excel.open">
                  <svg
                    width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.3335 23.168L20.0002 16.5013L13.3335 9.83464L13.3335 23.168Z" fill="black"/>
                  </svg>
                </div>
              </td>
              <td v-for="(td, columnIndex) in excel.mainData">
                <div v-if="editExcelIndex === rowIndex">
                  <slot name="edit"
                        :index="columnIndex"
                        :data="editExcelData.mainData[columnIndex]"
                        :raw="excel"
                        :funcSave="(data, errorMSG) => {
                          setEditExcelData(columnIndex, data, errorMSG)
                        }"
                  ></slot>
                </div>
                <div v-else>
                  <slot name="column"
                        :index="columnIndex"
                        :data="excel.mainData[columnIndex]"
                        :raw="excel"
                  ></slot>
                  <p v-if="excel.errorMSG" class="errMsg">{{ excel.errorMSG[columnIndex] || ""}}</p>
                </div>
              </td>
              <td>
                <row-edit-tool :data="rowIndex"
                            :value="editExcelIndex === rowIndex"
                            @open-edit-mode="onClickEditExcelData"
                            @close-edit-mode="onClickFinishExcelData"
                            @delete="onClickRemoveExcelData"
                            @cancel="onClickCancelExcelData"
                />
              </td>
            </tr>
            <tr v-if="excel.open" >
              <td :colspan="tableHeader.length + 3" class="p-0" style="border-bottom: none;">
                <div class="w-full border-bottom" style="max-height: 480px; overflow-y: auto; position: relative">
                  <slot name="columnDetail"
                        :detailData.sync="excel.detailData"
                        :funcSave="(detailData) => {
                          columnDetailSave(excel, rowIndex, detailData)
                        }"
                  >
                  </slot>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import ExcelJS from "exceljs";
import moment from "moment";
import RowEditTool from "@/views/excel-upload/RowEditTool.vue";
export default {
  components: {RowEditTool},
  props: {
    board: Object,
    header: Object,
    tableTitle: String,
    useFieldCell: Boolean, // post 의 stdInfo.field_name 을 엑셀의 사업장 데이터로 사용할 경우
    downloadLink: String,
    startReadSheet: Function,
    readExcelData: Function,
    finishReadSheet: Function,
    setSaveFormData: Function,
    value: [Object, Array],
    readonly: Boolean,

    tableHeader: Array,
  },

  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
    boardId() {
      return parseInt(this.$route.params.boardId);
    },
    checkAll() {
      if (0 < this.excelData.length && this.excelData.length === this.checkList.length) this.checkList = [];
      else this.checkList = this.excelData.map((_, i) => i);
    },
    openAll() {
      return true;
    }
  },

  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        if (value && value.length > 0) {
          this.excelData = value;
        }
      },
    },
    excelData: {
      deep: true,
      handler() {
        this.$emit("input", this.excelData);
      },
    },
  },

  data () {
    return {
      excelData: [],
      fields: [],
      editExcelIndex: null,
      editExcelData: [],
      checkList: [],
    }
  },

  async mounted() {
    if (this.useFieldCell) {
      await this.loadFieldListAll();
    }
  },
  methods: {

    loading(open) {
      const loadingDialog = new CustomEvent("loadingDialog", {
        detail: {
          open,
        },
      });
      window.dispatchEvent(loadingDialog);
    },
    // 엑셀을 읽어온 뒤, 사업장명 으로 사업장 데이터를 찾기위해 모든 사업장 불러오기
    async loadFieldListAll() {
      this.loading(true);
      const loadFieldList = (page) => {
        this.$store.dispatch("project/LOAD_FIELD_LIST", {
          projectId: this.projectId,
          page,
          perPage: 50,
        }).then((response) => {
          const data = response.data;
          this.fields.push(...data)
          if (response.last_page > page) {
            loadFieldList(page + 1);
          } else {
            this.loading(false);
          }
        });
      }
      await loadFieldList(1)
    },

    // 엑셀데이터 파싱
    readFile(event) {
      const workbook = new ExcelJS.Workbook();
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onload = (e) => {
        const buffer = reader.result;

        // 10000행 이상의 데이터는 읽지 않는다.
        const maxRow = 10000;
        workbook.xlsx.load(buffer).then((workbook) => {
          workbook.eachSheet((sheet) => {
            startReadSheet(sheet);
            sheet.eachRow((row, rowNumber) => {
              if (rowNumber > maxRow) {
                // 10000행 이상의 데이터는 읽지 않습니다.
                return;
              }

              const cells = ['']
              let countEmptyCell = 0;
              let foundEmpty = true;

              for (let i = 1; i<row.values.length; i++) {
                const text = `${row.getCell(i).text}`.trim();
                if (!text || text === 'undefined' || text === 'null' || text === 'NaN' || text === '') {
                  if (foundEmpty) {
                    countEmptyCell++;
                  }
                } else {
                  foundEmpty = false;
                }
                cells.push(text);
              }

              // 맨 앞에 빈 셀이 2개 이상이면 데이터가 없다고 판단
              if (countEmptyCell >= 2) {
                return;
              }

              getDataInSheet(sheet, rowNumber, cells)
            });
            finishSheet(sheet);
          });
          //
          // this.excelData = data;
        });
      };

      const findFieldByFieldName = (fieldName) => {
        return this.fields.find((field) => field.field_name === fieldName);
      }

      const getDataInSheet = (sheet, rowNumber, cells = []) => {
        const func = {
          rowIndex: this.excelData.length + 1,
          findFieldByFieldName: this.useFieldCell ? findFieldByFieldName : undefined,
          toTel: this.setPhone,
        }
        if (this.readExcelData) {
          const dataTypes = this.tableDataType;
          this.readExcelData(rowNumber, cells, dataTypes, func)
        }
      }

      const startReadSheet = (sheet) => {
        const func = {
          rowIndex: this.excelData.length + 1,
          save: (mainData, detailData, errorMSG) => {
            this.excelData.push({
              mainData,
              detailData,
              errorMSG,
              open: false,
            })
          },
        }
        if (this.startReadSheet) {
          this.startReadSheet(sheet, func)
        }
      }

      const finishSheet = (sheet) => {
        const func = {
          rowIndex: this.excelData.length + 1,
          save: (mainData, detailData, errorMSG) => {
            this.excelData.push({
              mainData,
              detailData,
              errorMSG,
              open: false,
            })
          },
        }
        if (this.finishReadSheet) {
          this.finishReadSheet(sheet, func)
        }
      }
    },

    setEditExcelData(columnIndex, data, errorMSG = undefined) {
      this.editExcelData.mainData[columnIndex] = data;
      if (typeof errorMSG === "string") {
        this.editExcelData.errorMSG[columnIndex] = errorMSG;
      }
      this.$set(this.editExcelData.mainData, columnIndex, data);
    },
    // 부모가 호출하는 함수
    clearData () {
      this.excelData = [];
      this.checkList = [];
    },
    // 부모가 호출하는 함수
    excelUpload() {
      const excelInput = this.$refs.excelInput;
      excelInput.value = null;
      excelInput.click();
    },
    onClickCheckRemove() {
      if (this.checkList.length < 1) return;
      this.excelData = this.excelData.filter((_, i) => !this.checkList.includes(i));
      this.excelData.forEach((_, i) => {
        _.values[0] = i + 1;
      });
      this.checkList = [];
    },
    onClickFinishExcelData(index) {
      this.$set(this.excelData, index, this.editExcelData);
      this.onClickCancelExcelData();
    },
    onClickCancelExcelData(index) {
      this.editExcelData = [];
      this.editExcelIndex = null;
    },
    onClickEditExcelData(index) {
      this.editExcelIndex = index;
      this.editExcelData = JSON.parse(JSON.stringify(this.excelData[index]));
    },
    onClickRemoveExcelData(index) {
      this.excelData.splice(index, 1);
    },
    onSelectField (rowIndex, columnIndex, field) {
      this.editExcelData.values[columnIndex] = {
        id: field.id,
        field_name: field.field_name,
      };
      this.editExcelData.errorMSG[columnIndex] = field.id ? "" : "입력된 데이터가 검색되지 않습니다.";
    },
    onClickOpenAll () {

    },
    columnDetailSave (excel, rowIndex, detailData) {
      this.excelData[rowIndex].detailData = detailData;
      this.$set(this.excelData, rowIndex, this.excelData[rowIndex]);
    }
  }
}
</script>

<style scoped lang="scss">
table {
  table-layout: fixed;
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    text-align: center;
    padding: 0;
  }

  th {
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;

    background: #fafafa;
    border-top: 1px solid #cdcdcd;
    border-bottom: 1px solid #cdcdcd;
    padding: 16px 0;
  }

  td {
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;

    border-bottom: 1px solid #cdcdcd;
    padding: 16px 0;
  }

  .check {
    justify-content: center !important;

    ::v-deep {
      span {
        margin: 0;
      }
    }
  }
  .border-bottom-none {
    border-bottom: none;
  }
}

.triangle-down {
  transition: all .3s ease;
  &.open {
    transform: rotate(90deg);
  }
}

.errMsg {
  font-weight: 400;
  font-size: 12px;
  line-height: 17px;
  text-align: center;
  color: #ea5455;
  margin-top: 2px;
}
</style>

